import { Bar, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;
import router from "../../router/router";

export default {
  extends: Bar,
  mixins: [reactiveProp],
  props: ["chartData", "title"],

  mounted() {
    this.renderChart(this.chartData, this.options);
  },

  computed: {
    options() {
      return {
        title: {
          display: true,
          text: this.title
        },
        responsive: true,
        maintainAspectRatio: false,
        events: ["click"],

        onClick: function(e, items) {
          if (items.length == 0) return; //Clicked outside any bar.

          e = items[0];
          //var x_value = this.data.labels[e._index];
          //var y_value = this.data.datasets[0].data[e._index];
          //var z_value = this.data.datasets[e._index].label;
          var link = this.data.datasets[e._index].link;

          router.push(link);
          //clickOnChart(lastHoveredIndex);
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true
              }
            }
          ]
        }
      };
    }
  }
};
